// Item rarity border colours for ground-drop orbs — vivid, high-contrast palette
const DROP_RARITY_COLORS = {
  common:    '#c8c8c8',
  uncommon:  '#00e676',
  rare:      '#29b6f6',
  epic:      '#ce93d8',
  legendary: '#ffab40',
};

/**
 * Renders XP orbs and item drops on the ground.
 * Props: groundDrops (array from s.groundDrops)
 */
export function GroundDropLayer({ groundDrops }) {
  if (!groundDrops?.length) return null;

  return groundDrops.map(gd => {
    if (gd.type === 'xp') {
      return (
        <div
          key={gd.id}
          className="ground-drop ground-drop--xp"
          style={{ transform: `translate3d(${gd.x}px,${gd.y}px,0)` }}
        />
      );
    }
    const rarityColor = DROP_RARITY_COLORS[gd.item?.rarity] ?? '#9e9e9e';
    return (
      <div
        key={gd.id}
        className="ground-drop ground-drop--item"
        style={{
          transform:   `translate3d(${gd.x}px,${gd.y}px,0)`,
          borderColor: rarityColor,
          boxShadow:   `0 0 8px ${rarityColor}cc, 0 0 20px ${rarityColor}88, 0 0 36px ${rarityColor}44`,
        }}
      >
        <span className="ground-drop-icon">{gd.item?.icon ?? '📦'}</span>
      </div>
    );
  });
}
